const ticketType = {
  name: {
    label: "Nom",
    invalid: {
      assertEmpty: "Le nom ne peut pas être vide."
    }
  },
  billable: {
    label: "facturable"
  },
  escalatable: {
    label: "Escaladable"
  },
  hiddenFromPartner: {
    label: "Caché au partenaire"
  },
  enableGfrtNotification: {
    label: "Notification de GTR"
  },
  description: {
    label: "Description",
    invalid: {
      assertEmpty: "La description ne peut pas être vide."
    }
  },
  billingType: {
    label: "Type de facturation",
    options: {
      time: "Par temps",
      responsability: "Par responsabilité",
      credit: "Par action / crédit"
    }
  }
};

export default ticketType;
